<div
  class="relative flex flex-col h-[calc(100dvh-var(--header-height,72px)-24px)] rounded-editor bg-(--ig-editor-background-color,#ebebeb) text-(--ig-editor-text-color)">
  <lib-editor-shell class="flex min-h-0 flex-1" [showSubmenu]="showSubMenu" [showOverlay]="showOverlay">
    <lib-main-menu
      editorMenu
      [disabled]="disabled || showSpinner || !hasActiveImage"
      [editMode]="editMode"
      (modeChanged)="onEditModeChanged($event)">
    </lib-main-menu>

    @if (showSubMenu) {
      <lib-sub-menu
        editorSubmenu
        [editorOptions]="editorOptions()"
        [editMode]="editMode"
        [imageSize]="imageSize"
        [detectionReady]="canDetectObjects"
        [detectionLoading]="detectionLoading"
        [detectedObjects]="detectedObjects"
        [detectionErrorKey]="detectionErrorKey"
        [detectionDownloadUrl]="detectionDownloadUrl"
        (closePanel)="onClosePanelRequest()"
        (detectionRequested)="onDetectObjects()"
        (detectionCancelled)="cancelObjectDetection()"
        (mergeApplied)="onMergeApplied()">
      </lib-sub-menu>
    }

    <lib-editor-workspace editorWorkspace [showTopPanel]="hasImageFile">
      @if (imageFile) {
        <lib-top-panel
          editorTopPanel
          [editMode]="editMode"
          [pageCount]="pageCount"
          [animationPreviewAvailable]="canToggleAnimationPreview"
          [animationPreviewPlaying]="animationPreviewPlaying"
          (animationPreviewToggled)="toggleAnimationPreview()"
          (download)="openDownloadWindow()">
        </lib-top-panel>
      }
      @if (!imageFile) {
        <lib-file-uploader
          editorEmptyState
          [toolSlug]="toolSlug()"
          [allowLocalFileUpload]="allowLocalFileUpload()"
          [multiple]="allowMultipleUpload"
          (uploadProcess)="onUploadProcess($event)"
          (fileUploaded)="onFileUploaded($event)"
          (extraFilesSelected)="onExtraFilesSelected($event)">
        </lib-file-uploader>
      }
      @for (page of previewPages; track page.pageIndex) {
        <lib-svg-canvas
          #preview
          editorCanvas
          class="h-full w-full"
          [class.hidden]="!page.isActive"
          [isActive]="page.isActive"
          [imageUrl]="resolveCanvasImageUrl(page)"
          [nativeAnimatedImageUrl]="resolveCanvasNativeAnimatedImageUrl(page)"
          [viewState]="resolveCanvasViewState(page)"
          [previewLoading]="resolveCanvasLoading(page)"
          [error]="resolveCanvasError(page)"
          [arrangeTiles]="page.isActive ? mergeArrangeTiles : null"
          [objectDetectionBoxes]="page.isActive && editMode === editModes.ObjectDetection ? detectedObjects ?? [] : []"
          (arrangeTileMoved)="onMergeTileDragged($event)">
        </lib-svg-canvas>
      }
      @if (hasImageFile && editMode === editModes.Animation) {
        <lib-animation-frame-panel
          editorAside
          [frames]="animationFrames"
          [processing]="uploadProcess"
          (filesSelected)="onAnimationFrameFilesSelected($event)"
          (frameReordered)="onAnimationFrameReordered($event)"
          (frameDurationChanged)="onAnimationFrameDurationChanged($event)"
          (frameDeleted)="onAnimationFrameDeleted($event)"
          (frameDuplicated)="onAnimationFrameDuplicated($event)">
        </lib-animation-frame-panel>
      } @else if (hasImageFile && editMode === editModes.Merge) {
        <lib-merge-image-panel
          editorAside
          [images]="mergeImages"
          [processing]="uploadProcess"
          [showPositions]="mergeLayout === 'custom'"
          (filesSelected)="onMergeImageFilesSelected($event)"
          (imageReordered)="onMergeImageReordered($event)"
          (imagePositionChanged)="onMergeImagePositionChanged($event)"
          (imageDeleted)="onMergeImageDeleted($event)"
          (imageDuplicated)="onMergeImageDuplicated($event)">
        </lib-merge-image-panel>
      }
    </lib-editor-workspace>
  </lib-editor-shell>
</div>
